module.exports = __webpack_public_path__ + "static/the-business-value-of-computers-dfea4b6c13a30cf5cafed91219a2f3c7.jpg";